// ===== Packages =====

import React, {
    useRef,
}                                   from 'react';
import {
    Transition as ReactTransition,
    TransitionStatus,
}                                   from 'react-transition-group';

type ReactTransitionProps = Omit<React.ComponentProps<typeof ReactTransition>, 'children' | 'nodeRef'>;
type Props = ReactTransitionProps & {
    children: (state: TransitionStatus) => React.ReactNode,
};

function Transition({ children, ...props }: Props): JSX.Element {
    const nodeRef = useRef<HTMLDivElement | null>(null);

    return (
        <ReactTransition
            {...(props as React.ComponentProps<typeof ReactTransition>)}
            nodeRef={nodeRef}
        >
            {(state) => (
                <div
                    ref={nodeRef}
                    style={{ display: 'contents' }}
                >
                    {children(state)}
                </div>
            )}
        </ReactTransition>
    );
}

export default Transition;
export { Transition };
